import Graduation from './Graduation';

export default Graduation;
